import React, { useCallback, useEffect, useState } from 'react';
import Lens from '@material-ui/icons/Lens';
import api from '../../services/api';

import './index.scss';

interface ParamsData {
  pv: number | undefined;
}

const StatusKeepAlive: React.FC<ParamsData> = ({ pv }) => {
  const [online, setOnline] = useState(false);

  useEffect(() => {
    handleGetStats();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      handleGetStats();
    }, Number(process.env.REACT_APP_TEMPO_RECONSULTA_KEEP_ALIVE));
    return () => clearInterval(timer);
  }, [online]);

  const handleGetStats = useCallback(async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_URL_GET_PONTOS_VENDA}keepalive/${pv}`, {
        headers: {
          'Access-Control-Allow-Origin': true,
        },
      }
      );
      setOnline(response.data.statusOnline);
    } catch (error) {
      setOnline(false);
    }
  }, []);

  return (
    <Lens className={online ? 'icon-status-online' : 'icon-status-offline'} />
  );
};

export default StatusKeepAlive;
